/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecoveringProduct } from '../../models/recovering-product';
import { UpdateRecoveringProductDto } from '../../models/update-recovering-product-dto';

export interface UpdateOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params {
  id: number;
      body: UpdateRecoveringProductDto
}

export function updateOneBaseMgmtRecoveringProductControllerRecoveringProduct(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProduct>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtRecoveringProductControllerRecoveringProduct.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecoveringProduct>;
    })
  );
}

updateOneBaseMgmtRecoveringProductControllerRecoveringProduct.PATH = '/api/mgmt/recovering-product/{id}';
